import { useEffect, useRef } from 'react'
import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'

const STEPS = [
  {
    element: '#tour-nav',
    popover: {
      title: '🗺️ Navigation',
      description: 'Accédez aux différentes vues de votre partie depuis ce panneau.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '#tour-tab-race',
    popover: {
      title: '🏁 Course',
      description: 'Supervise la course en temps réel.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '#tour-tab-podium',
    popover: {
      title: '🏆 Podium',
      description: 'Affiche le podium et le classement général.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '#tour-tab-stats',
    popover: {
      title: '📊 Stats',
      description: 'Consulte les statistiques de réponses par thème.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '#tour-tab-options',
    popover: {
      title: '⚙️ Options',
      description: 'Règle les paramètres de la course.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '#tour-controls',
    popover: {
      title: '🎮 Contrôles',
      description: "Gérez l'état de la course depuis ce panneau.",
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '#tour-btn-play',
    popover: {
      title: '▶️ En cours',
      description: 'La course est actuellement en cours.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '#tour-btn-pause',
    popover: {
      title: '⏸️ Pause',
      description: 'Met la course en pause, pour tous les participants.',
      side: 'right',
      align: 'center',
    },
  },
  {
    element: '#tour-btn-stop',
    popover: {
      title: '⏹️ Stop',
      description: 'Termine la course et affiche le podium et les stats.',
      side: 'right',
      align: 'center',
    },
  },
]

export default function RaceTour({ onDone }) {
  const driverRef = useRef(null)

  useEffect(() => {
    // Tour only on desktop — controls are hidden on mobile
    if (window.innerWidth < 640) {
      onDone?.()
      return
    }

    const d = driver({
      animate: true,
      showProgress: true,
      progressText: '{{current}} / {{total}}',
      nextBtnText: 'Suivant →',
      prevBtnText: '← Précédent',
      doneBtnText: 'Terminer',
      overlayOpacity: 0.55,
      popoverClass: 'kq-tour-popover',
      onDestroyed: () => onDone?.(),
      steps: STEPS,
    })
    driverRef.current = d

    const timer = setTimeout(() => d.drive(), 200)
    return () => {
      clearTimeout(timer)
      driverRef.current?.destroy()
    }
  }, [])

  return null
}
